import { LOCATIONS_SERVICES_DATA } from "@/lib/data";
import { Component } from "@builder.io/sdk";

export const locationsServicesConfig: Component = {
  name: "Location Services",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "location-services",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      helperText: "Additional CSS classes for the section",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Comprehensive Home Care Services",
      helperText: "Main heading for the section",
      required: true,
    },
    {
      name: "subheading",
      type: "string",
      defaultValue:
        "Providing Expert Care and Support for Every Stage of Life in San Francisco and the Bay Area",
      helperText: "Subheading text below the main heading",
      required: true,
    },
    {
      name: "description",
      type: "richText",
      helperText: "Description text for the section",
    },
    {
      name: "locationsServiceType",
      type: "list",
      required: true,
      subFields: [
        {
          name: "serviceType",
          type: "string",
          required: true,
          helperText: "Type of service (e.g., Families, Facilities)",
        },
        {
          name: "locationsServiceItems",
          type: "list",
          required: true,
          subFields: [
            {
              name: "image",
              type: "object",
              required: true,
              subFields: [
                {
                  name: "src",
                  type: "file",
                  allowedFileTypes: ["jpeg", "png"],
                  required: true,
                },
                {
                  name: "alt",
                  type: "string",
                  required: true,
                },
              ],
            },
            {
              name: "title",
              type: "string",
              required: true,
            },
            {
              name: "description",
              type: "longText",
              required: true,
            },
            {
              name: "button",
              type: "object",
              required: true,
              subFields: [
                {
                  name: "children",
                  type: "string",
                  required: true,
                },
                {
                  name: "href",
                  type: "string",
                  required: true,
                },
              ],
            },
          ],
        },
      ],
      defaultValue: LOCATIONS_SERVICES_DATA,
    },
  ],
};
